import { __decorate } from "tslib";
import { observable, action } from 'mobx';
export var PublicHeaderStyles;
(function (PublicHeaderStyles) {
    PublicHeaderStyles[PublicHeaderStyles["Default"] = 0] = "Default";
    PublicHeaderStyles[PublicHeaderStyles["Success"] = 1] = "Success";
    PublicHeaderStyles[PublicHeaderStyles["Warning"] = 2] = "Warning";
    PublicHeaderStyles[PublicHeaderStyles["Neutral"] = 3] = "Neutral";
})(PublicHeaderStyles || (PublicHeaderStyles = {}));
var StoreBuilderHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     * */
    function StoreBuilderHelpers() {
        /**If true if the current page is sign in page */
        this.IsSignIn = false;
        /**Is public route */
        this.IsPublicRoute = false;
        /**Page sub title */
        this.FooterGreetings = false;
        /**Define public header class */
        this.PublicHeaderStyle = PublicHeaderStyles.Default;
        return;
    }
    /**
     * Trigerred by Api History listner
     * @param {string} path History current path
     * @param {boolean} isPublicRoute If true display puvlic layout
     */
    StoreBuilderHelpers.prototype.HistoryChanged = function (pathname, isPublicRoute) {
        StoreBuilder.IsSignIn = pathname === '/' || pathname === '' || pathname.indexOf('sign') > -1;
        this.IsPublicRoute = isPublicRoute;
        if (this.IsSignIn || this.IsPublicRoute) {
            this.FooterGreetings = false;
        }
    };
    /**Set page titles */
    StoreBuilderHelpers.prototype.SetTitle = function (title, subTitle) {
        if (subTitle === void 0) { subTitle = null; }
        this.Title = title;
        this.SubTitle = subTitle;
    };
    /**Set public header class */
    StoreBuilderHelpers.prototype.SetPublicHeaderStyle = function (style) {
        this.PublicHeaderStyle = style;
    };
    __decorate([
        observable
    ], StoreBuilderHelpers.prototype, "IsSignIn", void 0);
    __decorate([
        observable
    ], StoreBuilderHelpers.prototype, "IsPublicRoute", void 0);
    __decorate([
        observable
    ], StoreBuilderHelpers.prototype, "Title", void 0);
    __decorate([
        observable
    ], StoreBuilderHelpers.prototype, "SubTitle", void 0);
    __decorate([
        observable
    ], StoreBuilderHelpers.prototype, "FooterGreetings", void 0);
    __decorate([
        observable
    ], StoreBuilderHelpers.prototype, "PublicHeaderStyle", void 0);
    __decorate([
        action
    ], StoreBuilderHelpers.prototype, "HistoryChanged", null);
    __decorate([
        action
    ], StoreBuilderHelpers.prototype, "SetTitle", null);
    __decorate([
        action
    ], StoreBuilderHelpers.prototype, "SetPublicHeaderStyle", null);
    return StoreBuilderHelpers;
}());
var StoreBuilder = new StoreBuilderHelpers();
export default StoreBuilder;
//# sourceMappingURL=StoreBuilder.js.map